import createCache from "@emotion/cache";
import { CacheProvider, useTheme } from "@emotion/react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Login from "@mui/icons-material/Login";
import MenuIcon from "@mui/icons-material/Menu";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import {
  Box,
  Drawer,
  Fab,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import moment from "jalali-moment";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import CharismaLogo from "../assets/logo/logo-ivest.svg";
import SideBar from "./sideBar.tsx";

const Medal_First = require("../assets/logo/Medal/award_medals_First.png");
const Medal_Second = require("../assets/logo/Medal/award_medals_Second.png");
const Medal_Third = require("../assets/logo/Medal/award_medals_Third.png");
var token: string | null = "";
interface UserLevel {
  charense_Amount: string;
  charense_level_ID: string;
  charense_level_Title: string;
}

function Header() {
  const [nowTime, setNowTime] = useState("");
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const [isShowMenu, setIsShowMenu] = useState<boolean>(true);
  const [decodedToken, setDecodedToken] = useState<any>({});
  const [userLevel, setUserLevel] = useState<UserLevel>({
    charense_Amount: "",
    charense_level_ID: "",
    charense_level_Title: "",
  });
  const [levelMedal, setLevelMedal] = useState();

  const checkMedalUi = () => {
    if (userLevel?.charense_level_ID) {
      switch (userLevel?.charense_level_ID) {
        case "1":
          setLevelMedal(Medal_First);
          break;
        case "2":
          setLevelMedal(Medal_Second);
          break;
        case "3":
          setLevelMedal(Medal_Third);
          break;
        default:
          return null;
      }
    }
  };
  useEffect(() => {
    checkMedalUi();
  }, [userLevel]);

  const theme = useTheme();
  const user = localStorage.getItem("user");
  token = localStorage.getItem("token");
  let decode: any = {};
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });
  const dateNow = moment(moment.now()).locale("fa").format("dddd DD MMMM YYYY");
  const params = document.URL;

  const styles = {
    icon: {
      backgroundColor: "#D61C4E",
      "&:hover": {
        backgroundColor: "#b90e3c",
      },
    },
    loggedIcon: {
      backgroundColor: "#23af0f",
      "&:hover": {
        backgroundColor: "#158904",
      },
    },
    menu: {
      width: "4rem",
      backgroundColor: "#efefef",
      "&:hover": {
        backgroundColor: "#ddd",
      },
    },
    iconMenu: {
      "&:hover": {
        backgroundColor: "none !important",
      },
    },
  };
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isTablet = useMediaQuery({
    query: "(max-width: 768px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });
  const currentDateTime = new Date();

  useEffect(() => {
    handleClose();
    if (token) {
      decode = jwtDecode(token);
      setDecodedToken(decode);
    }
    const tokenExpDate = new Date(decode.exp * 1000);
    if (
      tokenExpDate < currentDateTime &&
      params.split("/")[params.split("/").length - 1] !== "" &&
      params.split("/").at(-1)?.toLowerCase() !== "currencylist" &&
      params.split("/").at(-1)?.toLowerCase() !== "countriespercentage" &&
      params.split("/").at(-1)?.toLowerCase() !== "customerclub" &&
      params.split("/").at(-1)?.toLowerCase() !== "coinprices" &&
      params.split("/").at(-1)?.toLowerCase() !== "bonbast"
    ) {
      navigate("/login");
    } else {
      if (localStorage.getItem("userLevel")) {
        setUserLevel(JSON.parse(localStorage.getItem("userLevel") as string));
      }
    }
  }, [token]);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const hours = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
      const minutes =
        now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
      const seconds =
        now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
      setNowTime(hours + ":" + minutes + ":" + seconds);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (
      params.split("/")[params.split("/").length - 1] === "CurrencyRates" &&
      !token
    ) {
      setIsShowMenu(false);
    }
  }, []);

  const handleRouteToHome = () => {
    navigate("/RequestDetails");
    setAnchorEl(null);
  };
  const handleRouteToSearchRequest = () => {
    navigate("/searchRequest");
    setAnchorEl(null);
  };
  const handleRouteToRequestList = () => {
    navigate("/requestList");
    setAnchorEl(null);
  };
  const handleRouteToLogin = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("requestID");
    localStorage.removeItem("requestType");
    localStorage.removeItem("userLevel");
    localStorage.removeItem("requestName");
    localStorage.removeItem("customerName");
    localStorage.removeItem("requestDetails");
    navigate("/login");
  };
  const handleRouteToMyRequest = () => {
    navigate(`/RequestDetails/${user}`);
  };
  // ////////////////////////////////////////////////////////////////

  return (
    <CacheProvider value={cacheRtl}>
      <div>
        {params.split("/").at(-1)?.toLowerCase() !== "login" &&
        params.split("/").at(-1)?.toLowerCase() !== "currencylist" &&
        params.split("/").at(-1)?.toLowerCase() !== "countriespercentage" &&
        params.split("/").at(-1)?.toLowerCase() !== "customerclub" &&
        params.split("/").at(-1)?.toLowerCase() !== "bonbast" &&
        params.split("/").at(-1)?.toLowerCase() !== "coinprices" ? (
          <div className="header">
            <Tooltip title="نمایش منو">
              <IconButton
                sx={styles.menu}
                onClick={() => setOpenSideBar((prevState) => !prevState)}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>

            <Box
              sx={
                isDesktop
                  ? {
                      width: "96%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                    }
                  : {
                      width: "96%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                    }
              }
            >
              <div
                className="logoSection"
                style={isDesktop ? undefined : { marginLeft: "0.5rem" }}
              >
                <img src={CharismaLogo} style={{ width: "13rem" }} />
              </div>
              <div
                style={
                  isDesktop
                    ? { display: "flex", width: "17rem", alignItems: "center" }
                    : { display: "flex", alignItems: "center" }
                }
              >
                {isDesktop ? (
                  <p className="timeParagraph">
                    <span>{nowTime}</span>
                    <span>{dateNow}</span>
                  </p>
                ) : null}
                <Fab
                  sx={token ? styles.loggedIcon : styles.icon}
                  style={isDesktop ? undefined : { marginLeft: "0.5rem" }}
                  aria-label="add"
                  onClick={handleClick}
                >
                  <AccountCircleIcon
                    style={{ fontSize: "2.2rem", color: "#fff" }}
                  />
                </Fab>
                {token ? (
                  !decodedToken.role ? (
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {/* <MenuItem style={{cursor:'pointer'}} onClick={handleRouteToHome}>مشاهده جدول ارز ها <EuroIcon sx={{color:'#7e7e7e'}}/></MenuItem>
                {(decodedToken.role === 'Admin'|| decodedToken.role === 'Expert')?null:
                <MenuItem style={{cursor:'pointer'}} onClick={handleRouteToMyRequest}>گزارش سفارش<ContentPasteIcon sx={{color:'#7e7e7e'}}/></MenuItem>}
                {(decodedToken.role === 'Admin'|| decodedToken.role === 'Expert')?
                <MenuItem style={{cursor:'pointer'}} onClick={handleRouteToSearchRequest}>جستجوی سفارش <Search sx={{color:'#7e7e7e'}}/></MenuItem>
                :null} 
                {(decodedToken.role === 'Admin'|| decodedToken.role === 'Expert')?
                <MenuItem style={{cursor:'pointer'}} onClick={handleRouteToRequestList}>لیست کاربران <ListAltIcon sx={{color:'#7e7e7e'}}/></MenuItem>
                :null}  */}
                      <MenuItem style={{ cursor: "pointer" }}>
                        سطح شما:
                        <img
                          width={"25rem"}
                          src={levelMedal}
                          style={{ marginInline: "0.5rem" }}
                        />
                        {userLevel.charense_level_Title}
                      </MenuItem>
                      <MenuItem style={{ cursor: "pointer" }}>
                        میزان اعتبار: {userLevel.charense_Amount} کارنس
                      </MenuItem>
                      <MenuItem
                        style={{ cursor: "pointer" }}
                        onClick={handleRouteToLogin}
                      >
                        خروج <PowerSettingsNewIcon sx={{ color: "red" }} />
                      </MenuItem>
                    </Menu>
                  ) : (
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        style={{ cursor: "pointer" }}
                        onClick={handleRouteToLogin}
                      >
                        خروج <PowerSettingsNewIcon sx={{ color: "green" }} />
                      </MenuItem>
                    </Menu>
                  )
                ) : (
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      style={{ cursor: "pointer" }}
                      onClick={handleRouteToLogin}
                    >
                      ورود <Login sx={{ color: "green" }} />
                    </MenuItem>
                  </Menu>
                )}
              </div>
            </Box>
            <Drawer
              anchor="left"
              open={openSideBar}
              onClose={() => setOpenSideBar(false)}
            >
              <SideBar
                decodedToken={decodedToken}
                setOpenSideBar={setOpenSideBar}
              />
            </Drawer>
          </div>
        ) : null}
      </div>
    </CacheProvider>
  );
}

export { Header, token };
